// 采购订单-搜索
export const listConfigs = [
  {
    label: window.$t('purchase::purchase-list::order_num'),
    key: 'purchaseNo',
    searchType: 'input'
  },
  {
    label: window.$t('purchase::purchase-list::auditor'),
    key: 'auditor',
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'auth_user',
      placeholder: window.$t('purchase::purchase-list::supplier'),
      filterable: true,
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::creator'),
    key: 'createBy',
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'auth_user',
      placeholder: window.$t('purchase::purchase-list::supplier'),
      filterable: true,
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::supplier'),
    key: 'supplierId',
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'supplier_id',
      placeholder: window.$t('purchase::purchase-list::supplier'),
      filterable: true,
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::create_time'),
    key: 'CreateTime',
    searchType: 'selectDatepicker',
    componentData: {
      options: [{ keys: ['startCreateTime', 'endCreateTime'] }],
      dateComponentData: {
        startPlaceholder: window.$t('purchase::purchase-list::begin_time'),
        endPlaceholder: window.$t('purchase::purchase-list::end_time')
      },
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::audit_time'),
    key: 'AuditTime',
    searchType: 'selectDatepicker',
    componentData: {
      options: [{ keys: ['startAuditTime', 'endAuditTime'] }],
      dateComponentData: {
        startPlaceholder: window.$t('purchase::purchase-list::begin_time'),
        endPlaceholder: window.$t('purchase::purchase-list::end_time')
      },
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::re_auditor'),
    key: 'reviewer',
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'auth_user',
      placeholder: window.$t('purchase::purchase-list::supplier'),
      filterable: true,
      clearable: true
    }
  },
  {
    label: window.$t('purchase::purchase-list::re_audit_time'),
    key: 'ReviewTime',
    searchType: 'selectDatepicker',
    componentData: {
      options: [{ keys: ['startReviewTime', 'endReviewTime'] }],
      dateComponentData: {
        startPlaceholder: window.$t('purchase::purchase-list::begin_time'),
        endPlaceholder: window.$t('purchase::purchase-list::end_time')
      },
      clearable: true
    }
  }
]

// 采购明细-搜索
export const detailConfigs = () => {
  return [
    {
      key: ['searchType', 'searchValue'],
      searchType: 'selectInput',
      componentData: {
        // defaultValue: ['2', ''],
        options: [
          { label: window.$t('purchase::purchase-list::order_num'), value: 'purchaseNo' },
          { label: 'SKU', value: 'skuId' },
          { label: 'SPU', value: 'spuId' },
          { label: window.$t('purchase::purchase-list::product_name'), value: 'spuName' }
        ],
      }
    },
    // {
    //   label: window.$t('purchase::purchase-list::order_num'),
    //   key: 'purchaseNo',
    //   searchType: 'input'
    // },
    // {
    //   label: window.$t('purchase::purchase-list::sku'),
    //   key: 'skuId',
    //   searchType: 'input'
    // },
    // {
    //   label: window.$t('purchase::purchase-list::product_name'),
    //   key: 'spuName',
    //   searchType: 'input'
    // },
    {
      label: window.$t('purchase::purchase-list::supplier'),
      key: 'supplierId',
      searchType: 'dict',
      componentData: {
        cache: false,
        dictKey: 'supplier_id',
        placeholder: window.$t('purchase::purchase-list::supplier'),
        filterable: true,
        clearable: true
      }
    },
    {
      label: window.$t('purchase::purchase-list::计划到货日期'),
      key: 'q4',
      searchType: 'selectDatepicker',
      componentData: {
        options: [{ keys: ['startArrivalTime', 'endArrivalTime'] }],
        dateComponentData: {
          startPlaceholder: window.$t('purchase::purchase-list::begin_time'),
          endPlaceholder: window.$t('purchase::purchase-list::end_time')
        },
        clearable: true
      }
    }
  ]
}

// 采购订单状态
export const controlStatus = [
  {
    label: window.$t('purchase::purchase-list::wait_audit'),
    value: '1'
  },
  {
    label: window.$t('purchase::purchase-list::has_audit'),
    value: '2'
  },
  {
    label: window.$t('purchase::purchase-list::has_re_audit'),
    value: '3'
  },
  {
    label: window.$t('purchase::purchase-list::partial_arrival'),
    value: '4'
  },
  {
    label: window.$t('purchase::purchase-list::all_arrival'),
    value: '5'
  },
  {
    label: window.$t('purchase::purchase-list::finished'),
    value: '6'
  },
  {
    label: window.$t('purchase::purchase-list::closed'),
    value: '7'
  }
]

// 采购订单-表格
export const orderColumns = [
  {
    label: window.$t('purchase::purchase-list::order_num'),
    prop: 'purchaseNo',
    fixed: 'left',
    width: 250
  },
  {
    label: window.$t('purchase::purchase-list::supplier'),
    prop: 'supplier',
    width: 150
  },
  {
    label: window.$t('purchase::purchase-list::purchse_total_amount'),
    prop: 'totalPrice',
    width: 130,
    formatter: row => row.totalPrice.toFixed(2)
  },
  {
    label: window.$t('purchase::purchase-list::plan_arrival_date'),
    prop: 'arrivalTime',
    width: 220
  },
  {
    label: window.$t('purchase::purchase-list::create_info'),
    prop: 'createInfo',
    width: 260
  },
  {
    label: window.$t('purchase::purchase-list::autit_info'),
    prop: 'auditInfo',
    width: 260
  },
  {
    label: window.$t('purchase::purchase-list::re_audit_info'),
    prop: 'reviewInfo',
    width: 260
  },
  {
    label: window.$t('purchase::purchase-list::status'),
    prop: 'purchaseStatusName',
    fixed: 'right',
    width: 120
  },
  {
    label: window.$t('purchase::purchase-list::opt'),
    prop: 'operate',
    fixed: 'right',
    width: 210
  }
]

// 采购明细-表格
export const detailsColumns = [
  {
    label: window.$t('purchase::purchase-list::order_num'),
    prop: 'purchaseNo',
    fixed: 'left',
    width: 250
  },
  {
    label: window.$t('purchase::purchase-list::product_name'),
    prop: 'spuName',
    minWidth: 250
  },
  {
    label: window.$t('purchase::purchase-list::supplier'),
    prop: 'supplier',
    width: 130
  },
  {
    label: window.$t('purchase::purchase-list::amount'),
    prop: 'quantity',
    width: 200
  },
  {
    label: window.$t('purchase::purchase-list::single_price'),
    prop: 'skuPrice',
    width: 130
  },
  {
    label: window.$t('purchase::purchase-list::purchase_price'),
    prop: 'skuTotal',
    width: 150
  },
  // {
  //   label: window.$t('purchase::purchase-list::progress'),
  //   prop: 'progress',
  //   width: 250
  // },
  {
    label: window.$t('purchase::purchase-list::plan_arrival_date'),
    prop: 'arrivalTime',
    width: 200
  }
]

// 新增采购单-表单验证
export const addRules = {
  supplierId: [{ required: true, message: window.$t('purchase::purchase-list::supplier_input'), trigger: 'blur' }],
  arrivalTime: [{ required: true, message: window.$t('purchase::purchase-list::date_input'), trigger: 'blur' }],
  freight: [{ required: true, message: window.$t('purchase::purchase-list::purchase_price_input'), trigger: 'blur' }]
}

// 新增采购单-表格
export const addColumns = [
  // {
  //   label: window.$t('purchase::purchase-list::sku'),
  //   prop: 'skuId',
  //   width: 350
  // },
  {
    label: window.$t('purchase::purchase-list::product_name'),
    prop: 'title',
    minWidth: 400
  },
  {
    label: window.$t('purchase::purchase-list::single_price'),
    prop: 'skuPrice',
    slotHeaderName: 'skuPriceHeader',
    minWidth: 200
  },
  {
    label: window.$t('purchase::purchase-list::amount'),
    prop: 'quantity',
    minWidth: 200
  },
  {
    label: window.$t('purchase::purchase-list::total_amount'),
    prop: 'skuTotal',
    minWidth: 200
  },
  {
    label: window.$t('purchase::purchase-list::operate'),
    prop: 'operate',
    width: 100
  }
]

// 采购单详情-表格
export const detailColumns = [
  {
    label: window.$t('purchase::purchase-list::sku'),
    prop: 'skuId'
  },
  {
    label: window.$t('purchase::purchase-list::product_name'),
    prop: 'title',
    minWidth: 200
  },
  {
    label: window.$t('purchase::purchase-list::single_price'),
    prop: 'skuPrice',
    slotHeaderName: 'singlePriceHeader'
  },
  {
    label: window.$t('purchase::purchase-list::amount'),
    prop: 'quantity'
  },
  {
    label: window.$t('purchase::purchase-list::progress'),
    prop: 'progress'
  },
  {
    label: window.$t('purchase::purchase-list::total_amount'),
    prop: 'skuTotal'
  }
]

// 状态颜色
export const statusToColor = {
  1: '#FF9E00',
  2: '#0060FF',
  3: '#611EFF',
  4: '#EF4747',
  5: '#f59a23',
  6: '#00AF65',
  7: '#9CA3AA'
}
